// extracted by mini-css-extract-plugin
module.exports = {"category":"popular-category_category__w2GKs","categoryLink":"popular-category_categoryLink__AGR8N"};